import React, { useEffect, useState } from "react";
import Search from "../../../../components/Search";
import { useDispatch, useSelector } from "react-redux";
import { Table } from "antd";
import svg45 from "../../../../assets/svg/svg45.svg";
import svg46 from "../../../../assets/svg/svg46.svg";
import svg29 from "../../../../assets/svg/svg29.svg";
import { useNavigate } from "react-router-dom";
import CardLoading from "../../../../components/CardLoading";
import useModalToggle from "../../../../custom_hooks/useModalToggle";
import DocumentAdd from "./DocumentAdd";
import { fetchData } from "../../../../features/fetch/fetchSlice";
import moment from "moment";
import { fetchFiles } from "../../../../features/fetch/fetchSlice";
import ConfirmModal from "../../../../components/ConfirmModal";
import { formatText } from "../../../../utils";
import toast from "react-hot-toast";
import { save } from "../../../../features/save/saveSlice";
import BreadCrumb from "../../../../layout/BreadCrumb";

function LicenseTable({ setView }) {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const url = "prod/get_members";
  const { loading, count, data } = useSelector((state) => ({
    loading: state.fetch.loading,
    data: state.fetch.data[url] || [],
    count: state.fetch.count[url] || 0,
    periods: state.fetch.periods,
  }));
  const { iwuaObj } = useSelector((state) => state.obj);
  const [searchInput, setsearchInput] = useState(null);
  const [prodd, setProdd] = useState("");
  const { open, handleCancel, handleOpen } = useModalToggle();

  const handleSearch = (e) => {
    setsearchInput(e.target.value);
    dispatch(
      fetchData({
        url: url,
        fullNames: e.target.value == "" ? null : e.target.value,
        usrInstId: iwuaObj?.instId,
        start: 0,
        limit: null,
      })
    );
  };

  const handleEdit = async () => {
    await handleOpen();
  };
  const handleAdd = async () => {
    await setProdd();
    await handleOpen();
  };

  const [openDelete, setOpenDelete] = useState(false);
  const handleOpenDelete = () => {
    setOpenDelete(true);
  };
  const handleCloseDelete = () => {
    setOpenDelete(false);
  };

  const handleDelete = async () => {
    const res = await dispatch(
      save({
        url: "api/v2/projectFiles/delete",
        pfId: prodd?.pfId,
      })
    );
    if (res?.payload?.success) {
      await toast.success(res?.payload?.message);
      await setOpenDelete(false);
      await fetchTableData();
    } else {
      toast.error(res?.payload?.message);
    }
  };

  const [pageIndex, setPageIndex] = useState(0);
  const [pageSize, setPageSize] = useState(10);

  async function fetchTableData(page, size) {
    await dispatch(
      fetchData({
        url: url,
        limit: size ?? pageSize,
        start: page ?? pageIndex,
        usrInstId: iwuaObj?.instId,
      })
    );
  }
  useEffect(() => {
    fetchTableData();
  }, []);

  const downloadFile = async (item) => {
    try {
      const res = await dispatch(fetchFiles({ file: item }));
      if (res?.payload) {
        window.open(res.payload, "_blank");
      }
    } catch (error) {
      console.error("Failed to open file:", error);
    }
  };

  const columns = [
    {
      title: "#",
      dataIndex: "index",
      key: "index",
      render: (_, record, index) => {
        if (record?.isGroup) {
          return {
            children: (
              <div className="scheme-custom-header">
                {record?.usrMemberTypeHeader}
              </div>
            ),
            props: { colSpan: columns?.length },
          };
        }

        let num = 1;
        for (let i = 0; i < index; i++) {
          if (data[i].isGroup) {
            num = 1;
          } else {
            num++;
          }
        }
        return num;
      },
    },
    {
      title: "Title",
      dataIndex: "fullNames",
      render: (_, record) => (record.isGroup ? { props: { colSpan: 0 } } : _),
    },
    {
      title: "Licensing Organization",
      dataIndex: "usrMemberType",
      render: (_, record) => (record.isGroup ? { props: { colSpan: 0 } } : _),
    },
    {
      title: "Date Created",
      dataIndex: "createdDate",
      render: (text, record) => {
        if (record?.isGroup) {
          return { props: { colSpan: 0 } };
        }
        return text ? moment(text).format("DD-MM-YYYY") : "--";
      },
    },
    {
      title: "Expiry Date",
      dataIndex: "createdDate",
      render: (text, record) => {
        if (record?.isGroup) {
          return { props: { colSpan: 0 } };
        }
        return text ? moment(text).format("DD-MM-YYYY") : "--";
      },
    },
    {
      title: "Status",
      dataIndex: "damStatus",
      render: (item,record) => {
        if (record.isGroup) return { props: { colSpan: 0 } };
        const colors = {
          ACTIVE: "#ABEFC6",
        };

        return (
          <div
            className="text-[#067647] inline-block rounded-[8px] px-[8px] py-[4px] w-auto !text-[12px]"
            style={{
              backgroundColor: colors[item] || "darkGreen",
            }}
          >
            {formatText(item)}
          </div>
        );
      },
    },
    {
      title: "Actions",
      render: (item, record) => {
        if (record.isGroup) return { props: { colSpan: 0 } };
        return (
          <>
            <div
              className="flex items-center gap-x-[.62rem]"
              onClick={() => setProdd(item)}
            >
              <img
                src={svg45}
                alt="svg45"
                className="cursor-pointer"
                onClick={() => downloadFile(item?.pfFilePath)}
              />
              <img
                className="cursor-pointer"
                src={svg46}
                alt="svg46"
                onClick={() => handleOpenDelete()}
              />
            </div>
          </>
        );
      },
    },
  ];

  if (loading && !searchInput) return <CardLoading />;
  return (
    <>
      <BreadCrumb breadcrumbs={[{ title: "Licenses" }]} />
      <div className="lg:min-h-[88vh] mt-[1.25rem] flex flex-col white_card">
      <div className="form-add-h">
        Licenses
        </div>
        <div className="flex flex-col w-full flex-1 mt-[2.5rem] ">
          <div className="flex lg:flex-row flex-col-reverse lg:items-center justify-between  gap-y-4">
            <div className="lg:w-[29.1875rem] w-auto ">
              <Search
                searchInput={searchInput}
                handleSearch={handleSearch}
                text={"Search..."}
              />
            </div>
            <div className="w-[150px]">
              <button onClick={() => handleAdd()} className="cstm-btn-2">
                <img src={svg29} alt="svg29" />
                <span className="">Upload</span>
              </button>
            </div>
          </div>

          <Table
            rowClassName={(record) => (record.isGroup ? "group-row" : "")}
            rowSelection={false}
            bordered={false}
            pagination={{
              position: ["bottomRight"],
              current: pageIndex + 1,
              total: count,
              pageSize: pageSize,
              onChange: (page, size) => {
                setPageIndex(page - 1);
                setPageSize(size);
                fetchTableData(page - 1, size);
              },
              showSizeChanger: false,
              hideOnSinglePage: true,
            }}
            rowKey="key"
            columns={columns}
            dataSource={data}
            scroll={{
              x: 1200,
            }}
            className="mt-[1.25rem] custom-tables"
            loading={loading}
          />
        </div>
        <DocumentAdd
          isModalOpen={open}
          handleCancel={handleCancel}
          handleFetch={fetchTableData}
          prodd={prodd}
        />

        <ConfirmModal
          open={openDelete}
          handleCancel={handleCloseDelete}
          handleSubmit={handleDelete}
          loading={loading}
          content="Are you sure you want perfom this action?"
          type="alert"
          btnTitle="Delete"
        />
      </div>
    </>
  );
}

export default LicenseTable;
